import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Nav, NavItem, DropdownMenu,DropdownToggle,UncontrolledDropdown,CustomInput, DropdownItem } from 'reactstrap';
//import { AppSidebarNav } from '@coreui/react';
import { connect } from 'react-redux';
import { ORDERS_FULL_ACCESS_URL, ORDERS_GENERAL_DETAILS_URL, ORDER_ROUTE_URLS } from '../../utils/permissions';

class CustomSidebar extends Component {
	constructor(props) {
		super(props);
		var fullParamsSearch = window.location.href.split('=');
		var paramsSearch = fullParamsSearch && fullParamsSearch[1] && fullParamsSearch[1].length > 0 ? fullParamsSearch[1].split(','): []
		/*this.state = {
			includeRangeInput:paramsSearch,
			url:'/order-management/search-status=',
		}*/
		this.state = {
			navbar:[]
		}
	}
	componentDidMount(){
		this.handlePermissions();
	}

	componentDidUpdate(prevProps){
		if(prevProps.location.pathname !== this.props.location.pathname){
			this.handlePermissions();
		}
	}

	handlePermissions(){
		const { admin_type } = this.props.session;
		let newNavBar = this.props.navConfig.visibles == null ?
		this.props.navConfig.items
		:
		this.props.navConfig.items
		//.filter((item,key) => item.name != "Inventario")
		.filter( (item,key) => {
			let a = []
			if(item.children){
				a = item.children.filter( (children,key) => {
					return this.props.navConfig.visibles.includes(children.lang_key)
				})
				item.children = a
			}
			return  item.lang_key !== '' || (item.lang_key == '' && item.children && item.children.length > 0 )
		})
		//console.log('componentDidMount newNavBar',newNavBar)

		//TODO ver por que esta redirgiendo a orders-management

		const currentUrl = window.location.pathname;
		const splitUrl = currentUrl.split('/');
		const allowedUrls = new Set();
		allowedUrls.add('');
		allowedUrls.add('profile');
		allowedUrls.add('inbox');
		allowedUrls.add('notifications');

		function collectAllowedUrls(items) {
			items.forEach(item => {
			if (item.url) {
				const splitItemUrl = item.url.split('/');
				allowedUrls.add(splitItemUrl[1]);
			}
			if (item.children) {
				collectAllowedUrls(item.children);
			}
			});
		}

		collectAllowedUrls(newNavBar);

		let defaultKey = null;

		if(admin_type){
			if(allowedUrls.has(admin_type.default)){
				defaultKey = admin_type.default_key;
			}
		}

		// El detalle/edición de una orden vive bajo /order-management/:id, así que cualquier
		// permiso sobre alguna vista de órdenes lo habilita aunque no tenga "Órdenes Generales".
		// La lista general (/order-management y /order-management/search-...) sí requiere su permiso.
		const isOrderSubRoute = splitUrl[1] === ORDERS_FULL_ACCESS_URL
			&& !!splitUrl[2]
			&& !splitUrl[2].startsWith('search-');
		const hasAnyOrdersView = ORDER_ROUTE_URLS.some(url => allowedUrls.has(url));

		// /orders-general/:id es el detalle abierto desde Órdenes Generales: requiere ese permiso.
		const urlToCheck = splitUrl[1] === ORDERS_GENERAL_DETAILS_URL ? ORDERS_FULL_ACCESS_URL : splitUrl[1];

		if (!allowedUrls.has(urlToCheck) && !(isOrderSubRoute && hasAnyOrdersView)) {
			window.location.href = `/${defaultKey || ""}`;
		}

		this.setState({navbar:newNavBar});
	}

	render() {
		var items = []
		/*if(this.props.navConfig && this.props.navConfig.items){
			items = this.props.navConfig.items.map( (item,key) => {
				if((item.name != "Inventario" && this.props.branch.id == undefined) || (this.props.branch.id)){

					var addItem = <Link className={`nav-link aside_link ${item.url === window.location.pathname ? `active`:`` } ${ this.props.isZupper ? `zupper` : ``}`} to={item.url||'#'}>
							<i className={`nav-icon ${item.icon}`}></i>
							{item.name}
						</Link>

					if( item.children){
						addItem = <UncontrolledDropdown className="aside_link">
							<DropdownToggle nav >
								<i className={`nav-icon ${item.icon}`}></i>
								{item.name}
							</DropdownToggle>
							<DropdownMenu className={`pl-3`}>
								{/*onClick={(e)=>this.urlBuilder()}
								{
									item.children.map( (children,key) => {
										var exist = this.state.includeRangeInput.findIndex(( item ) => item === children.name.toLowerCase() );
										return <CustomInput key={key} id={ `nav-${key}` }
											onChange={(e) => this.urlBuilder(e.target)}
											type="checkbox"
											value={children.name.toLowerCase()}
											name={item.name}
											label={children.name }
											checked={ exist !== -1 ? true : false }
											data-type="checkbox"/>
									})
								} * /}
								{
									item.children.map( (children,key) => {
										return <DropdownItem key={key}>
											<Link  to={children && children.url || "#"} style={{textDecoration: 'none', color: '#000'}}>
												{children.name}
											</Link>
										</DropdownItem>
									})
								}
							</DropdownMenu>
						</UncontrolledDropdown>
					}
					return <NavItem key={key}>{addItem}</NavItem>
				}
			})
		}*/

		/*addItem;
				if(this.props.company && this.props.company.settings && this.props.company.settings.enable_multi_providers === true){
					if(item.lang_key !== 'providers_settings'){
						addItem = <Link className={`nav-link`} to={item.url}>
							<i className={`nav-icon ${item.icon}`}></i>
							{item.name}
						</Link>
					}
				}else{*/
		/*<AppSidebarNav navConfig={ this.props.navConfig } /> */

		if(this.props.navConfig && this.props.navConfig.items){
			items = this.state.navbar.map( (item,key) => {
				if(((item.name != "Inventario" && item.lang_key != "create-order") && this.props.branch.id == undefined) || (this.props.branch.id)){
					var addItem = <Link className={`nav-link aside_link ${item.url === window.location.pathname ? `active`:`` } ${ this.props.isZupper ? `zupper` : ``}`} to={item.url||'#'}>
							<i className={`nav-icon ${item.icon}`}></i>
							{item.name}
						</Link>

					if(item.children){
						addItem = <UncontrolledDropdown className="aside_link">
							<DropdownToggle nav >
								<i className={`nav-icon ${item.icon}`}></i>
								{item.name}
							</DropdownToggle>
							<DropdownMenu className={`pl-3`}>
								{
										item.children.map( (children,key) => {
											if(children.lang_key != "branch-invoices" && !this.props.branch.id || this.props.branch.id){
													return <DropdownItem key={key}>
														<Link to={children && children.url || "#"} style={{textDecoration: 'none', color: '#000'}}>
														{children.name}
													</Link>
												</DropdownItem>
											}
									})
								}
							</DropdownMenu>
						</UncontrolledDropdown>
					}
					return <NavItem key={key}>{addItem}</NavItem>
				}
			})
		}
		return <div className={`scrollbar-container sidebar-nav ps ps--active-y`}>
			<Nav>{items}</Nav>
		</div>
	}
}

//export default CustomSidebar;
const mapStateToProps = (state) => {
	let zupper = false;
	if(state.company){
		if(state.company.id === 7  || state.company.id === 120){
			zupper = true
		}
	}
	return {
		company:state.company,
		isZupper:zupper
	}
}

export default connect(mapStateToProps)(CustomSidebar);



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/CustomSidebar.jsx